import React, { useCallback, useEffect, useRef } from 'react';
interface CountdownTimerProps {
  className?: string;
  boxClassName?: string;
  textClassName?: string;
  labelClassName?: string;
}
function getEndTime(): number {
  try {
    const saved = localStorage.getItem('megapack_countdown_end');
    if (saved) {
      const t = parseInt(saved, 10);
      if (t > Date.now()) return t;
    }
  } catch {}
  const t = Date.now() + 23 * 3600000 + 58 * 60000 + 33000;
  try {
    localStorage.setItem('megapack_countdown_end', t.toString());
  } catch {}
  return t;
}
function calcDisplay(endTime: number) {
  const d = endTime - Date.now();
  if (d <= 0) return {
    h: '00',
    m: '00',
    s: '00'
  };
  return {
    h: String(Math.floor(d / 3600000 % 24)).padStart(2, '0'),
    m: String(Math.floor(d / 60000 % 60)).padStart(2, '0'),
    s: String(Math.floor(d / 1000 % 60)).padStart(2, '0')
  };
}
export function CountdownTimer({
  className = 'flex gap-4 justify-center',
  boxClassName = 'bg-brand-dark border border-brand-border rounded-xl p-4 min-w-[90px] flex flex-col items-center',
  textClassName = 'text-5xl font-heading font-bold text-brand-accent',
  labelClassName = 'text-xs uppercase tracking-widest text-white/50 mt-2 font-badge font-bold'
}: CountdownTimerProps) {
  const endTimeRef = useRef(0);
  const hRef = useRef<HTMLSpanElement>(null);
  const mRef = useRef<HTMLSpanElement>(null);
  const sRef = useRef<HTMLSpanElement>(null);
  // Initialize endTime in effect to avoid synchronous localStorage during render
  const initRef = useRef(false);
  const update = useCallback(() => {
    const d = calcDisplay(endTimeRef.current);
    if (hRef.current) hRef.current.textContent = d.h;
    if (mRef.current) mRef.current.textContent = d.m;
    if (sRef.current) sRef.current.textContent = d.s;
  }, []);
  useEffect(() => {
    if (!initRef.current) {
      endTimeRef.current = getEndTime();
      initRef.current = true;
      update();
    }
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, [update]);
  const initial = calcDisplay(Date.now() + 23 * 3600000 + 58 * 60000 + 33000);
  return <div className={className} data-id="element-62">
      <div className={boxClassName} data-id="element-63">
        <span ref={hRef} className={textClassName} style={{
        fontVariantNumeric: 'tabular-nums'
      }} data-id="element-64">
          {initial.h}
        </span>
        <span className={labelClassName} data-id="element-65">hs</span>
      </div>
      <div className="text-5xl font-bold text-white/30 self-start mt-3" data-id="element-66">:</div>
      <div className={boxClassName} data-id="element-67">
        <span ref={mRef} className={textClassName} style={{
        fontVariantNumeric: 'tabular-nums'
      }} data-id="element-68">
          {initial.m}
        </span>
        <span className={labelClassName} data-id="element-69">min</span>
      </div>
      <div className="text-5xl font-bold text-white/30 self-start mt-3" data-id="element-70">:</div>
      <div className={boxClassName} data-id="element-71">
        <span ref={sRef} className={textClassName} style={{
        fontVariantNumeric: 'tabular-nums'
      }} data-id="element-72">
          {initial.s}
        </span>
        <span className={labelClassName} data-id="element-73">seg</span>
      </div>
    </div>;
}